<template>
   <div><b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading></div>
</template>
<script>
import axios from 'axios';
export default {
   data() {
      return {
         isFullPage: true,
         isLoading: true,
         message: this.$route.params.message || ''
      };
   },
   created() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.token;
      axios
         .post('/logout')
         .then(() => {
            localStorage.removeItem('access_token');
            this.$store.commit('logout');
            this.$router.push({
               name: 'login',
               params: { message: this.message }
            });
         })
         .catch(() => {
            localStorage.removeItem('access_token');
            this.$store.commit('logout');
            this.$router.push({
               name: 'login',
               params: { message: this.message }
            });
         });
   }
};
</script>
